export enum ProductGroupChannel {
  CREATE = 'productGroup::create',
  EDIT = 'productGroup::patch',
  DELETE = 'productGroup::delete',
}
